






import {
    defineComponent,
    reactive,
    onMounted,
    ref,
} from '@vue/composition-api';
import QrCode from './qrcode/index.vue';
import { AcceptError, QueryInfo } from './qrcode/model';
import { appendSearchParamsToUrl } from '@/common/util';

interface ServiceOwnToken {
    code: string;
    state: string;
}

export default defineComponent({
    components: {
        QrCode,
    },
    setup(props, context) {
        const isLoading = ref(true);
        const {
            redirect_uri,
            size = '280',
            href,
        }: QueryInfo = context.parent!.$route.query as any;

        function redirectTo(serviceOwnToken: ServiceOwnToken) {
            if (serviceOwnToken.code && redirect_uri) {
                window.location.href = appendSearchParamsToUrl(
                    redirect_uri,
                    serviceOwnToken,
                );
            }
        }

        function acceptLogin(serviceOwnToken: string) {
            redirectTo(JSON.parse(serviceOwnToken));
        }

        function initStyle() {
            if (!href) {
                return;
            }
            const linkNode = document.createElement('link');
            linkNode.rel = 'stylesheet';
            linkNode.type = 'text/css';
            linkNode.href = href;
            document.head.appendChild(linkNode);
        }

        // 漏洞详情：https://security-info.corp.kuaishou.com/securityServices/publicBug/bugDetail?VUL-202409-1039
        // 修复方案：https://docs.corp.kuaishou.com/d/home/fcACzKSSSqDxvpwFI8Mr76pD4
        function needInitStyle() {
            if (!href) {
                return;
            }

            try {
                const decodeHref= decodeURIComponent(href);
                const hrefUrl = new URL(decodeHref);

                // endsWith 兼容性不好
                if (hrefUrl.pathname.indexOf('.css', hrefUrl.pathname.length - 4) !== -1) {
                    initStyle();
                }
            } catch (err) {
                // href不是url，无需处理
            }
        }

        onMounted(() => {
            needInitStyle();
            isLoading.value = false;
        });

        return {
            acceptLogin,
            size,
            href,
            isLoading,
        };
    },
});
